import React from 'react';
import {PageTitle} from '../../../_metronic/layout/core';
import {Link, useParams} from 'react-router-dom'


const SalesPediaPageFish = () => {
  return (
<>
  <PageTitle breadcrumbs={[{title:"Anasayfa",path:"/",isActive:true,isSeparator:false},{title:"Balık Restoranları",path:"/",isActive:true,isSeparator:true}]}>{"Balık Restoranları"}</PageTitle>
    <div className="card mb-5 mb-xl-10">
      <div className="card mb-0">
        <div className="card-body mb-0">
          <div className="mb-0">
            <h3 className="text-black mb-7">Balık Restoranları</h3>
            <div className="separator separator-dashed mb-9"></div>
            <div className="row">
              <div className="col-md-12">
                <div className="h-100 d-flex flex-column justify-content-between pe-lg-6 mb-lg-0 mb-10">
                  <div className="mb-3">
                  {/*  <div className="bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-350px"
                         style={{backgroundImage:"url('media/image/Verona-restaurants-new-blog-banner.jpg')"}}></div>*/}

                 <iframe className="embed-responsive-item card-rounded h-375px w-100"
                            src="https://www.youtube.com/embed/uUkKrS6UsFw" ></iframe>
                  </div>
                  <div className="mb-5">
                    <a href="#" className="fs-2 text-dark fw-bolder text-hover-primary text-dark lh-base">İtalyan Mutfağının Lezzet Sırları
                      <br/>Kaliteli Malzemeler Seçin</a>
                    <div className="fw-bold fs-5 text-gray-600 text-dark mt-4">İtalyan usulü pişirmek ve yemek için kolay uygulanabilir ipuçları!
                      İtalyanlar, dünyanın en lezzetli mutfağına sahip olmakla övünürler. Bu mutfağa biraz yakından bakıldığında,
                      övünmelerinin nedenini anlamak güç değil.
                      İtalyan mutfağının bu kadar lezzetli olması, kaliteli malzemeler kullanmaya ve işleri olabildiğince basitleştirmeye dayanıyor.
                      Yavaş pişirmek, yavaş yemek ve mutfaktan olabildiğince keyif almak, İtalyanların mutlu sofralar için uyguladığı önemli ipuçlarından.
                      Kendi mutfağınızda İtalya’nın lezzet sırlarını uygulayabilmeniz için bazı püf noktalarını bir araya getirdik. Afiyet olsun!
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div className="card card-flush h-lg-100">
          <div className="card-header">
            <div className="card-title flex-column">
              <h3 className="fw-bolder mb-1">Dosyalar</h3>
            </div>
          </div>
          <div className='col-md-6'>
          <div className="card-body p-9 pt-3">
            <div className="d-flex flex-column mb-9">
              <div className="d-flex align-items-center mb-5">
                <div className="symbol symbol-30px me-5">
                  <img alt="Icon" src={'media/svg/files/pdf.svg'}/>
                </div>
                <div className="fw-bold">
                  <Link className="fs-6 fw-bolder text-dark text-hover-primary" to={'/salespediafilepage/BalikRestoranlarinaOzelUrunListesi.pdf'}>Balık Restoranlarına Özel Ürün Listesi</Link>
                  <div className="text-gray-400">2 days ago
                    <a href="#">Karina Clark</a></div>
                </div>
                <button type="button"
                        className="btn btn-clean btn-sm btn-icon btn-icon-primary btn-active-light-primary ms-auto"
                        data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-flip="top-end">
                  <span className="svg-icon svg-icon-3">
																<img alt={"icon"} src={"media/icons/duotone/Communication/Share.svg"}/>
									</span>
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
</>
  )
}

export default SalesPediaPageFish